export default "__VITE_ASSET__CnTUzpLL__"